import { MaximizeIcon } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";
import { ContentCopyButton } from "~/components/ContentCopyButton";
import { MarkdownExportButton } from "~/components/MarkdownExportButton";
import { Button } from "~/components/ui/button";
import { stripSourcesFromContent } from "../../helpers";

export const ReportActions = ({
  disabled,
  onMaximize,
  content,
  exportFileName,
  reportTitle,
  caseInfo,
}: {
  disabled: boolean;
  onMaximize: () => void;
  content: string;
  exportFileName: string;
  reportTitle?: string;
  caseInfo?: {
    caseName: string;
    dateOfBirth: string;
    dateOfLoss: string;
    claimNumber: string;
  };
}) => {
  const { formatMessage } = useIntl();
  return (
    <div className="w-full h-8 px-6 items-center flex border-t border-border justify-center">
      <div className="flex gap-1 xl:gap-2">
        <Button
          variant="ghost"
          size="mini"
          disabled={disabled}
          onClick={onMaximize}
        >
          <MaximizeIcon className="w-4 h-4 mr-2" />
          <FormattedMessage id="common.maximize" defaultMessage="Maximize" />
        </Button>
        <ContentCopyButton
          content={content}
          size="mini"
          eventName="app/doc_list/copy_all.button/click"
          disabled={disabled}
        />
        <MarkdownExportButton
          content={content}
          fileName={exportFileName}
          disabled={disabled}
          buttonSize="mini"
          openEventName="app/doc_list/export.button/click"
          exportEventName="app/doc_list/export_menu_open/export_action.link/click"
          title={reportTitle || formatMessage({ id: `chat.report.title` })}
          transformContent={stripSourcesFromContent}
          caseInfo={caseInfo}
        />
      </div>
    </div>
  );
};
